import { Button } from '@bambi/component-library/src/components/Button/Button';
import { useCallback, useState } from 'react';

import { useEditInvoiceById } from '../../invoices/management/useEditInvoice';

interface InvoiceNumberCellProps {
  invoiceNumber: string;
  invoiceId: string;
}
export function InvoiceNumberCell({
  invoiceNumber,
  invoiceId,
}: InvoiceNumberCellProps) {
  const [isLoading, setIsLoading] = useState(false);
  const editInvoiceById = useEditInvoiceById();

  const handleEditInvoice = useCallback(async () => {
    setIsLoading(true);
    await editInvoiceById(invoiceId);
    setIsLoading(false);
  }, [editInvoiceById, setIsLoading, invoiceId]);

  return (
    <Button variant="anchor" onClick={handleEditInvoice} loading={isLoading}>
      {invoiceNumber}
    </Button>
  );
}
